import IconButton from './IconButton.vue';

export default IconButton;
